import { url } from "./url_config";

export async function getDeviceDetails(deviceHwid, id, token, date) {
    try {
        const response = await fetch(`${url}devices/${deviceHwid}?id=${id}&date=${date}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });

        if(!response.ok) {
            return { error: true, status_code: response.status };
        }

        const data = await response.json();

        if (data.error === true) {
            return { error: true, message: data.message || "API error" };
        }

        return { error: false, data: data.body };

    } catch (e) {
        console.error("getDeviceDetails error:", e);
        return null;
    }
}